import { initialState } from "./state";

export const videos = (state = initialState, action) => {
  switch (action.type) {
    case "SET_VIDEOS_LIST": {
      return Object.assign({}, state, {
        videoList: action.data
      });
    }
    default:
      return state;
  }
};
